import { useEffect, useRef, useState } from "react";
import {  useSelector } from "react-redux";
import { RootState } from "../../redux/Store/store";
import { useGetParentStudentInfoQuery } from "../../redux/API/StartTest/startTestApi";
import { getItem } from "../../utils/token";
import SideBarV1 from "./SideBarV1";
import { DashboardWidgets } from "./DashboardCards";
import DashboardBackground from "../../components/ReUsableComponents/DashboardBackground";
import HeaderV1 from "./HeaderV1";

const ParentDashboard = () => {

  const { data: parentAssociatedData, isSuccess: parentAssociatedSuccess } = useGetParentStudentInfoQuery({});

  const scrollRef = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [showTopFade, setShowTopFade] = useState(false);
  const [showScroll, setShowScroll] = useState(false);

  const { parentStudentId } = useSelector(
    (state: RootState) => state.root.startFullTest
  );

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    setShowScroll(true);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setShowScroll(false);
    }, 1000);
    
    const atTop = el.scrollTop === 0;
    setShowTopFade(!atTop);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      el.addEventListener('scroll', handleScroll);
      handleScroll();
    }

    return () => {
      el?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const userRole = getItem("userRole");
  return (
    <>
      {userRole === "PARENT" ? (
        <DashboardBackground>
          {parentAssociatedData?.data?.length > 0 ? (
          <>
            <div className="p-5 flex gap-[1%] w-full">
            {/* Sidebar */}
              <SideBarV1/>

              <section className="flex flex-col justify-center items-start gap-[2vh]" style={{width: "calc(100vw - 240px)",height: "calc(100vh - 40px)"}}>
                
                <HeaderV1/>
        
                <div className="py-2 pr-1 w-full flex flex-grow justify-between items-center self-stretch rounded-[28px] border-[0.5px]  border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive" style={{height: "calc(100vh - 12vh - 40px)"}}>
                  <div ref={scrollRef} className={`h-full py-2 pl-3 w-full widgetScroll ${showScroll ? 'showScroll' : 'hideScroll'}`}>
                    <DashboardWidgets  studentId={parentStudentId}/>
                  </div>
                  {/* Top Gradient */}
                  {showTopFade && (
                    <div
                      className="absolute top-2 left-3 z-10 h-10 pointer-events-none"
                      style={{
                        width: 'calc(100vw - 266px)',
                        background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.56) 50%, rgba(255, 255, 255, 0.75) 100%)',
                      }}
                    />
                  )}
                  {/* Bottom Gradient */}
                  <div 
                    className="absolute bottom-1 left-3 rounded-b-lg h-10 pointer-events-none"  
                    style={{
                      background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.56) 50%, rgba(255, 255, 255, 0.75) 100%)",
                      width: "calc(100vw - 266px)"
                    }}
                  />
                  </div>

              </section>
            </div>
          </>
          ) : (
            <div className="flex items-center justify-center w-full">
              <div className="bg-satPrepTransWhite p-20 w-fit h-fit rounded-[28px] border-[0.5px] border-satPrepGrey shadow-widget-card backdrop-blur-sevenFive">
                <p className="text-3xl text-satPrepBlack font-gully font-bold text-center">
                  The student has not accepted your invitation yet.
                </p>
              </div>
            </div>
          )}
        </DashboardBackground>
      ) : (
        <div className="flex items-center justify-center overflow-hidden flex-col mt-80">
          <p className="text-3xl text-lightBlack">
            You are not authorized to access this page.
          </p>
        </div>
      )}
    </>
  );
};

export default ParentDashboard;
